export default "__VITE_ASSET__07ddde58__"